import { formatTime } from "../lib/api";
import { useT } from "../i18n";

const IDS = { exit: "victory", gas: "game-over" };

export const EndModal = ({ end, onRestart, onMenu, onBoard, onLoginSave }) => {
  const t = useT();
  const c = { id: IDS[end.type], ...t[end.type] };
  return (
    <div className={`overlay overlay-${end.type}`} data-testid={`${c.id}-modal`}>
      <div className="panel panel-enter">
        <p className={`eyebrow eyebrow-${end.type}`}>{c.eyebrow}</p>
        <h2 className="title">{c.title}</h2>
        <p className="lead">{c.text}</p>
        <div className="end-stats">
          <div><span className="hud-label">{t.level}</span><span className="end-value" data-testid={`${c.id}-level`}>{t.levels[end.level]}</span></div>
          <div><span className="hud-label">{t.time}</span><span className="end-value" data-testid={`${c.id}-time`}>{formatTime(end.stats.time)}</span></div>
          {end.type === "exit" && (
            <div><span className="hud-label">{t.rank}</span><span className="end-value" data-testid="victory-rank">{end.rank ? `#${end.rank}` : end.saveError || end.needsLogin ? "—" : "..."}</span></div>
          )}
        </div>
        {end.saveError && <p className="error" data-testid="save-error">{t.saveError}</p>}
        {end.needsLogin && (
          <div className="login-save" data-testid="login-to-save">
            <p className="lead">{t.loginToSave}</p>
            <button className="btn-primary" onClick={onLoginSave} data-testid="login-and-save-button">{t.loginAndSave}</button>
          </div>
        )}
        <div className="row">
          <button className={end.needsLogin ? "btn-ghost" : "btn-primary"} onClick={onRestart} data-testid={`${c.id}-restart-button`}>
            {end.type === "exit" ? t.newMaze : t.restart}
          </button>
          <button className="btn-ghost" onClick={onMenu} data-testid={`${c.id}-menu-button`}>{t.changeLevel}</button>
          <button className="btn-ghost" onClick={onBoard} data-testid={`${c.id}-leaderboard-button`}>{t.leaderboard}</button>
        </div>
        <p className="hint hide-touch">{t.enterHint}</p>
      </div>
    </div>
  );
};
